import React, { useContext, useEffect, useRef, useState } from 'react';
import styled, { keyframes } from "styled-components";
import { AppContext } from '../../contexts/AppContext';

const Wrapper = styled.div`
overflow-x: hidden;
overflow-y: hidden;
margin: 12px;
width: -webkit-fill-available;
width: -moz-available;
text-align: center;
`;

const CellText = styled.p`
font-size: 14px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.color};
display: inline-block;
white-space: nowrap;
font-family: DINNextLTPro-Regular;

animation: ${props =>
    props.offset && keyframes`
    0%, 20% {
        transform: translateX(0px)
    }
    40%, 60% {
        transform: translateX(calc(calc(100% - ${props.offset}) - 100%))
    }
    
    80%, 100% {
        transform: translateX(0px)
    }`};

animation-duration: 6s;
animation-iteration-count: infinite;
animation-timing-function: ease-in-out;
`;

const CellImg = styled.img`
src: "${props => props.src}";
width: 70px;
margin-top: 1px;
`;

export function Cell({ text, image, color, dynamicText }) {

    const defaultText = 'Unassigned';
    const ref = useRef(null);
    const textRef = useRef(null);
    const [offsetWidth, setOffsetWidth] = useState('0px');
    const [showImage, setShowImage] = useState(true);
    const { currentTheme } = useContext(AppContext);

    useEffect(() => {
        if (!dynamicText) {
            return;
        }

        const width = ref.current ? ref.current.offsetWidth : 0;
        const textWidth = textRef.current ? textRef.current.offsetWidth : 0;

        if (width >= textWidth) {
            return; //space available
        }
        const diff = textWidth - width;
        setOffsetWidth(`${diff}px`);

    }, [ref.current ? ref.current.offsetWidth : 0]);

    return (
        <Wrapper ref={ref}>
            { text &&
                <CellText ref={textRef} color={color || currentTheme.dashboard.row.fontColor}
                    offset={dynamicText ? `${offsetWidth}` : undefined}>
                    {text}
                </CellText>
            }
            { image && showImage &&
                <CellImg src={`${process.env.REACT_APP_RESOURCE_URL}resources/${image}`} onError={() => setShowImage(false)} />
            }

            { image && !showImage &&
                <CellText ref={textRef} color={color || currentTheme.dashboard.row.fontColor}
                    offset={dynamicText ? `${offsetWidth}` : undefined}>
                    {text}
                </CellText>
            }
        </Wrapper>
    );
}